export const FEATURE_FLAG_CODES_OF_PRACTICE = "codesOfPractice"
